var _defs, _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _rect2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _g, _rect3, _rect4, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _rect5, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _rect6, _rect7, _path41, _path42, _rect8, _path43, _path44, _path45, _path46, _path47;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobInterviewMonochromatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 406,
    height: 306,
    viewBox: "0 0 773.54 579.71",
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 411.27,
    y1: 437.24,
    x2: 412.48,
    y2: 725.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 257.93,
    y1: 519.76,
    x2: 249.85,
    y2: 616.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 376.17,
    y1: 435.39,
    x2: 405.64,
    y2: 435.39,
    gradientTransform: "translate(153.39 -41.82) rotate(-21.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 552.34,
    y1: 100.11,
    x2: 590.74,
    y2: 100.11,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 598)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 156.07,
    y1: 492.43,
    x2: 190.78,
    y2: 537.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 137.28,
    y1: 527.6,
    x2: 140.24,
    y2: 577.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 102.54,
    y1: 532.58,
    x2: 99.85,
    y2: 608.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 102.06,
    y1: 544.76,
    x2: 100.63,
    y2: 585.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 138.47,
    y1: 533.84,
    x2: 135.78,
    y2: 610.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 137.98,
    y1: 545.21,
    x2: 136.56,
    y2: 585.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 174.41,
    y1: 535.11,
    x2: 171.72,
    y2: 611.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 173.97,
    y1: 545.47,
    x2: 172.48,
    y2: 587.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 640.38,
    y1: 492.43,
    x2: 675.09,
    y2: 537.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 621.59,
    y1: 527.6,
    x2: 624.55,
    y2: 577.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 586.85,
    y1: 532.58,
    x2: 584.16,
    y2: 608.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 586.38,
    y1: 544.76,
    x2: 584.94,
    y2: 585.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 622.79,
    y1: 533.84,
    x2: 620.1,
    y2: 610.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 622.29,
    y1: 545.21,
    x2: 620.87,
    y2: 585.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 658.72,
    y1: 535.11,
    x2: 656.03,
    y2: 611.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 658.28,
    y1: 545.47,
    x2: 656.79,
    y2: 587.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 423.98,
    y1: 217.03,
    x2: 439.32,
    y2: 215.42,
    gradientTransform: "translate(27.93 -45.28) rotate(6.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 374.55,
    y1: 237.05,
    x2: 392.69,
    y2: 237.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 223.16,
    y1: 476.92,
    x2: 273.09,
    y2: 476.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 228.95,
    y1: 320.63,
    x2: 352.18,
    y2: 208.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 252.48,
    y1: 467.12,
    x2: 86.48,
    y2: 126.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 79.34,
    y1: 339.51,
    x2: 302.63,
    y2: 354.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 152.91,
    y1: 284.33,
    x2: 235.27,
    y2: 256.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 361.99,
    y1: 362.24,
    x2: 384.45,
    y2: 362.24,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 598)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 140.84,
    y1: 375.72,
    x2: 188.87,
    y2: 239.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 210.94,
    y1: 324.62,
    x2: 252.66,
    y2: 331.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 218.9,
    y1: 263.5,
    x2: 280.45,
    y2: 263.5,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 598)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 178.18,
    y1: 496.2,
    x2: 353.75,
    y2: 382.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 329,
    y1: 528.2,
    x2: 235.77,
    y2: 566.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 626.1,
    y1: 412.27,
    x2: 778.84,
    y2: 412.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 632.64,
    y1: 421.13,
    x2: 692.18,
    y2: 421.13,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 598)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 522.75,
    y1: 387.84,
    x2: 795.58,
    y2: 295.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 596.99,
    y1: 331.94,
    x2: 673.7,
    y2: 375.84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 180.65,
    y1: 429.4,
    x2: 254.86,
    y2: 429.4,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 598)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 210.58,
    y1: 214.99,
    x2: 239.1,
    y2: 405.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 377.43,
    y1: 352.64,
    x2: 430.33,
    y2: 594.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 416.08,
    y1: 303.32,
    x2: 412.05,
    y2: 472.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 321.87,
    y1: 536.88,
    x2: 245.45,
    y2: 568.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 256.29,
    y1: 545.15,
    x2: 251.58,
    y2: 601.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 536.95,
    y1: 229.11,
    x2: 844.49,
    y2: 405.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 539.24,
    y1: 262.47,
    x2: 595.13,
    y2: 262.47,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 598)",
    xlinkHref: "#linear-gradient-3"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Interviewing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.69,566.27c-5.36,2-11.28,8.47-7,12.26,1.5,1.34,3.7,1.48,5.71,1.56q306.86,11.34,614,5.43c5.7-.12,12.49-.86,15.15-5.9s-1-11.74-6.26-14.24-11.31-2.09-17.1-1.74a398.88,398.88,0,0,1-75-2.54c-7.91-1-16-2.33-23.06-5.94-4.86-2.48-9.16-6-14.08-8.33-8.09-3.9-17.32-4.51-26.28-5q-99.89-5.55-200-3.07-50,1.25-99.93,4.5c-13.1.85-28.33-.18-40.69,4.55s-22.06,10-35.45,11.53C161.89,562.75,130.58,555.72,101.69,566.27Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M230.87,559.82a7.47,7.47,0,0,0,.86,4,9.94,9.94,0,0,0,3.72,3.16,232.38,232.38,0,0,0,29.68,13.76c2.43.86,5,1.86,7.59,1.57s5.16-2.15,5.45-4.73c.29-2.15-1.15-4.15-2.44-5.87-6.88-9.18-14-18.35-21.36-27.24a8.34,8.34,0,0,0-1.57-1.57,7.6,7.6,0,0,0-2.58-.72c-4.88-.72-13.62-3.87-17.63.57C229,546.63,230.72,555,230.87,559.82Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#aa68fc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M230.87,559.82a7.47,7.47,0,0,0,.86,4,9.94,9.94,0,0,0,3.72,3.16,232.38,232.38,0,0,0,29.68,13.76c2.43.86,5,1.86,7.59,1.57s5.16-2.15,5.45-4.73c.29-2.15-1.15-4.15-2.44-5.87-6.88-9.18-14-18.35-21.36-27.24a8.34,8.34,0,0,0-1.57-1.57,7.6,7.6,0,0,0-2.58-.72c-4.88-.72-13.62-3.87-17.63.57C229,546.63,230.72,555,230.87,559.82Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269.09,17.42c27.67-11.9,59.2-5.16,89.3-4.88,42.15.29,86-12.33,125.28,2.73,23.37,8.88,42.15,26.8,60.21,44.14,27.09,26.09,54.75,52.9,71.81,86.44,7,13.9,12.33,29,22.51,40.71,18.92,21.5,49.74,26.23,76.25,37.12,48.88,20.22,86.44,66.52,93.89,118.84S792,450.88,748,480c-38.56,25.52-86.87,29.53-133,32.83L344.92,532.16c-60.63,4.3-122.7,8.6-181-8.75C112.42,508.22,62,472.24,43.47,420.06c-21.93-61.35,9.89-122.7,37.27-176.88,17.2-34,37.84-63.79,62.21-93C177.64,108.87,218.63,39.06,269.09,17.42Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#aa68fc",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M667,233.49c5.78.95,23.82,3,25.83-2.42,1-2.55-2.67-14.45-2.69-17.22,0-6.18-5.16-8.47-7.43-14.2a2.53,2.53,0,0,0-.8-1.22,2.45,2.45,0,0,0-2.47.36c-5.5,3.25-17.74,5.23-19.7,11.56C667.8,213.85,664.48,228.32,667,233.49Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M590.75,548.07a107.69,107.69,0,0,1-31.1.28c2.58-6.3,5.16-12.9,4.87-19.78-.14-4.87-1.86-9.6-3.3-14.33a193.72,193.72,0,0,1-8.74-49.31c-.15-4.3-.15-8.89,2.43-12.33,1.73-2.29,4.45-3.58,7.17-4.58,22.08-8,22.65,16.48,24.23,31.24C588.89,502.2,590.32,525.13,590.75,548.07Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M173.19,476.54h0a8.17,8.17,0,0,1,8.18,8.17v71.82H165V484.71A8.17,8.17,0,0,1,173.19,476.54Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#aa68fc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 99.05,
    y: 539.92,
    width: 78.55,
    height: 10.61,
    rx: 5.3,
    fill: "#aa68fc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M173.19,476.54h0c4.52,0,8.18,3.26,8.18,7.29v64.06H165V483.83C165,479.8,168.68,476.54,173.19,476.54Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-5)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 99.05,
    y: 539.92,
    width: 78.55,
    height: 10.61,
    rx: 5.3,
    fill: "url(#linear-gradient-6)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 101.63,
    cy: 558.41,
    r: 7.45,
    fill: "#aa68fc"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.61,
    cy: 558.41,
    r: 7.45,
    fill: "#aa68fc"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.59,
    cy: 558.41,
    r: 7.45,
    fill: "#aa68fc"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.63,
    cy: 558.41,
    r: 7.45,
    fill: "url(#linear-gradient-7)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.58,
    cy: 558.53,
    r: 3.97,
    fill: "url(#linear-gradient-8)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.61,
    cy: 558.41,
    r: 7.45,
    fill: "url(#linear-gradient-9)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.52,
    cy: 558.19,
    r: 3.94,
    fill: "url(#linear-gradient-10)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.59,
    cy: 558.41,
    r: 7.45,
    fill: "url(#linear-gradient-11)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.52,
    cy: 558.35,
    r: 4.12,
    fill: "url(#linear-gradient-12)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M657.51,476.54h0a8.17,8.17,0,0,1,8.17,8.17v71.82H649.34V484.71A8.17,8.17,0,0,1,657.51,476.54Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#aa68fc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 583.36,
    y: 539.92,
    width: 78.55,
    height: 10.61,
    rx: 5.3,
    fill: "#aa68fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.51,476.54h0c4.51,0,8.17,3.26,8.17,7.29v64.06H649.34V483.83C649.34,479.8,653,476.54,657.51,476.54Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 583.36,
    y: 539.92,
    width: 78.55,
    height: 10.61,
    rx: 5.3,
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 585.94,
    cy: 558.41,
    r: 7.45,
    fill: "#aa68fc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 621.92,
    cy: 558.41,
    r: 7.45,
    fill: "#aa68fc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 657.9,
    cy: 558.41,
    r: 7.45,
    fill: "#aa68fc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 585.94,
    cy: 558.41,
    r: 7.45,
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 585.89,
    cy: 558.53,
    r: 3.97,
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 621.92,
    cy: 558.41,
    r: 7.45,
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 621.84,
    cy: 558.19,
    r: 3.94,
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 657.9,
    cy: 558.41,
    r: 7.45,
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 657.83,
    cy: 558.35,
    r: 4.12,
    fill: "url(#linear-gradient-20)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 370.91,
    y: 165.06,
    width: 69.52,
    height: 107.79,
    transform: "translate(-58.68 40.33) rotate(-6.62)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 370.91,
    y: 165.06,
    width: 69.52,
    height: 107.79,
    transform: "translate(-58.68 40.33) rotate(-6.62)",
    fill: "#aa68fc"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 370.91,
    y: 165.06,
    width: 69.52,
    height: 107.79,
    transform: "translate(-58.68 40.33) rotate(-6.62)",
    opacity: 0.69,
    fill: "url(#linear-gradient-21)",
    style: {
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M389.86,213.33A3.37,3.37,0,0,1,392,214c.89.81.81,2.24.43,3.38-1.19,3.55-4.44,6-6.2,9.32-4.35,8.2,1.45,19-2.54,27.33a12.83,12.83,0,0,1-7.95,6.73,16.77,16.77,0,0,1-1.18-7C374.47,244.39,376.59,212.71,389.86,213.33Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-22)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.54,193.87c-2.73-9.32-5.74-18.92-12.33-26.09s-17.92-10.89-26.23-6c-2.58,16.63-5.16,33.69-2.15,50.31s12.47,33,27.81,39.71C79.16,262,79.16,281.88,80.45,298.65c3,38.85,6.17,77.69,9.18,116.54.86,10.89,1.72,21.93,6.45,31.82,7.74,16.49,25.08,26.81,42.86,30.68s36.26,2.15,54.32.43c12.33-1.15,25.09-2.58,35.41-9.32s17.49-20.21,12.76-31.54C235,421.78,213.9,420.78,197,420.21a198.24,198.24,0,0,1-46.73-6.88c-3.44-.86-7-2-9.75-4.45-3.29-3-4.73-7.45-5.87-11.61-10.32-36.41-11.62-75.77-8.46-113.46C129,252.27,114.57,223.83,105.54,193.87Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M225.08,439.84c3.44,34.41,3.44,69.1,3.44,103.64a276.39,276.39,0,0,0,29,.57,158.4,158.4,0,0,1,1.72-24.65c.86-5.59,2.15-11.18,3.15-16.91a181.7,181.7,0,0,0-2.15-75.12,71.75,71.75,0,0,0-3.44-11.18c-1-2.43-2.43-5-4.87-6s-5.59-.14-8.17.72c-5.16,1.72-10.46,3.44-15.63,5.3-3.58,1.15-10.46,2.15-12.18,5.88-1.72,3.44.86,5.88,3.3,7.88C223.08,433,224.65,434.54,225.08,439.84Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M225.08,439.84c3.44,34.41,3.44,69.1,3.44,103.64a276.39,276.39,0,0,0,29,.57,158.4,158.4,0,0,1,1.72-24.65c.86-5.59,2.15-11.18,3.15-16.91a181.7,181.7,0,0,0-2.15-75.12,71.75,71.75,0,0,0-3.44-11.18c-1-2.43-2.43-5-4.87-6s-5.59-.14-8.17.72c-5.16,1.72-10.46,3.44-15.63,5.3-3.58,1.15-10.46,2.15-12.18,5.88-1.72,3.44.86,5.88,3.3,7.88C223.08,433,224.65,434.54,225.08,439.84Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-23)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M182.51,212.79c-4.73-.72-9.6-1.43-14.33-1a50.45,50.45,0,0,0-9,2c-6.31,1.72-12.47,3.73-18.06,7.17-8.89,5.59-14.91,14.62-20.36,23.65a277.82,277.82,0,0,0-18.35,35.55c-3.58,8.6-6.59,17.78-5.87,27.09.28,3,.86,6,2.58,8.46a23.06,23.06,0,0,0,6.73,6.16c3.3,2.3,6.45,4.59,9.75,6.88,2.58,1.87,5.88,3.73,8.6,2.15,1.29,28,1.72,55.76,3,83.57.15,4,3.44,11.33,7.31,12.62,2.73.86,3-3.3,5.31-4.88C156.28,411,169.75,395.84,186,384.08s36.55-20.35,55.76-15.19c-2.15-27.38-4-54.9-5.59-82.28,21.22,5.74,39.13,20.79,60.49,26.09,2.87.72,5.88,1.29,8.75.72,3.15-.58,5.87-2.58,8.45-4.45,18.21-12.9,36.56-25.8,54.76-38.7a6.67,6.67,0,0,0,3-3.3c.72-2-.43-4-1.43-5.87-3-5.16-5.88-10.32-8.89-15.34a146,146,0,0,1-59.2,29.1c-3.3.71-6.74,1.43-10,.43s-5.74-3.16-8.17-5.31c-11.62-10.32-22.65-21.5-35.12-30.67s-26.67-16.77-42.15-19.07c-8-1.14-17.77-1.72-21.78-8.88A22.29,22.29,0,0,0,182.51,212.79Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#aa68fc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M371.58,267a6.67,6.67,0,0,1-3,3.3c-18.2,12.9-36.55,25.8-54.76,38.7-2.58,1.87-5.3,3.87-8.45,4.45-2.87.57-5.88,0-8.75-.72-21.36-5.3-39.27-20.35-60.49-26.09l3.6-53.12c11.64,8.86,33.16,26.73,44.14,36.49,2.43,2.15,5,4.45,8.17,5.31s6.73.28,10-.43a146,146,0,0,0,59.2-29.1c3,5,5.88,10.18,8.89,15.34C371.15,263,372.3,265,371.58,267Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#aa68fc"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M371.58,267a6.67,6.67,0,0,1-3,3.3c-18.2,12.9-36.55,25.8-54.76,38.7-2.58,1.87-5.3,3.87-8.45,4.45-2.87.57-5.88,0-8.75-.72-21.36-5.3-39.27-20.35-60.49-26.09l3.6-53.12c11.64,8.86,33.16,26.73,44.14,36.49,2.43,2.15,5,4.45,8.17,5.31s6.73.28,10-.43a146,146,0,0,0,59.2-29.1c3,5,5.88,10.18,8.89,15.34C371.15,263,372.3,265,371.58,267Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-24)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M236.12,286.61c1.58,27.38,3.44,54.9,5.59,82.28-19.21-5.16-39.56,3.44-55.76,15.19S156.28,411,139.8,422.21c-2.3,1.58-2.58,5.74-5.31,4.88-3.87-1.29-7.16-8.6-7.31-12.62-1.29-27.81-1.72-55.61-3-83.57-2.72,1.58-6-.28-8.6-2.15-3.3-2.29-6.45-4.58-9.75-6.88a23.06,23.06,0,0,1-6.73-6.16c-1.72-2.44-2.3-5.45-2.58-8.46-.72-9.31,2.29-18.49,5.87-27.09a277.82,277.82,0,0,1,18.35-35.55c5.45-9,11.47-18.06,20.36-23.65,5.59-3.44,11.75-5.45,18.06-7.17a50.45,50.45,0,0,1,9-2c4.73-.43,9.6.28,14.33,1a22.29,22.29,0,0,1,2.3-1.43c4,7.16,13.76,7.74,21.78,8.88a80.71,80.71,0,0,1,24.5,8.09c6.19,3.12,3.09,1.08,8.63,5.16.69.5-1.88,15.22-1.21,15.74Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-25)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M150.67,343.81l0-8.08a1,1,0,0,1,.15-.63,1,1,0,0,1,.81-.24l31.19.4a1.86,1.86,0,0,1,1.53.51,1.83,1.83,0,0,1,.2,1.23l-.34,4.8a1,1,0,0,1-1.25,1.2h-15.2c-4.57,0-10.79-1.13-15.2,0-2.74.7-2.09,1.31-2.16,4.43q-.09,3.6-.15,7.21-.12,7.2-.1,14.42c0,8,.17,16.09.9,24.1.1,1.11,2.82,13.21,2.66,13.38l-18.59,19s-6.85-.87-7.31-12.61-4.13-83.28-4.13-83.28l14.42-30.17,16.69-37.13s-3.18,41.81-4.28,80.69",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-26)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M216.34,240.46c-6.43-24.52-12.54-19.48-22.63-17.87s-10.77,13.57-10.77,13.57c2.7,15.09,3,51.12,2.7,75.63-.14,20.78-4.1,38.42-.81,58.92.29,2-4,5.35-2,6.21a5.61,5.61,0,0,0,3.73,0c9.6-2.3,17.2-10.32,26.94-11.9,1.15-.14,2.44-.43,2.87-1.29a2.78,2.78,0,0,0,.29-1.15c2.72-21.78,5.3-43.57,8-65.5.72-6.31,1.58-12.76.72-19.21-1.58-11.9-8.31-35.55-8.74-35.12",
    transform: "translate(-36.16 -7.86)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M183.27,238.59c.75,5.56,3.62,10.08,7.48,14.16a1.47,1.47,0,0,0,.87.54,1.45,1.45,0,0,0,.87-.33,19.64,19.64,0,0,0,7-8,17.67,17.67,0,0,1,1.22,7.94c-.46,6.19.54,12.7-.29,18.85-1.95,14.41-3.87,26.15-9.25,42.9,4.39,2.12,12.11-1.55,13.91-6.09s1.13-9.61.79-14.48c-1.46-20.86,3.76-42.1-.44-62.59a5.12,5.12,0,0,0-1.55-3.21,5.29,5.29,0,0,0-3.15-.74q-6.61-.1-13.23.32a5.75,5.75,0,0,0-3.24.88C182.27,230.26,182.94,236.16,183.27,238.59Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-27)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M173.91,213.65c-.43,1.43.29,2.87.86,4.3,5,10.75,10.61,21.22,16.49,31.39a135.58,135.58,0,0,1,10.46-18.92,2,2,0,0,1,1-.86,1.48,1.48,0,0,1,1.15.72c3.73,3.87,7.6,7.74,12.47,10.18,2.44,1.14,5.16,2.15,6.59,4.44,1.58.14,1.87-2.15,1.58-3.73a89.59,89.59,0,0,0-5.88-16.77c-2-4.3-4.87-9-9.6-9.89-2.29-.43-4.73.14-7,.14-7,.15-9.89-4.44-15.34-7.59C182.23,204.33,175.35,208.92,173.91,213.65Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M201.72,243.9a21.83,21.83,0,0,1,2.15,3c1.15,2.58,0,5.44-.86,8.17-1.86,5.73-2.44,11.89-2.87,18.06-1.29,19.78-2.15,39.56-5.73,59.05a21.29,21.29,0,0,0-.57,6,16.74,16.74,0,0,0,2.15,5.87l5.16,10.32a63.47,63.47,0,0,0,8.31-17.2,27.51,27.51,0,0,0,1-4.73,22.26,22.26,0,0,0-.86-6.88c-2.72-12.61-2-22.56-1.22-36.55,1.43-10.61,3.37-22.36,4.09-33,.14-2.72,0-5.88-2-7.88-.71-.58-1.57-1.15-1.72-2a3.49,3.49,0,0,1,.15-1.72c.43-1.72,1-3.44,1.43-5.16a2,2,0,0,0,.14-1.29c-.14-.72-1-1.15-1.72-1.43a12.37,12.37,0,0,1-6.16-6.74c.29.72-3,5.16-3.15,6.59A11.3,11.3,0,0,0,201.72,243.9Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#aa68fc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M364.13,239.31c-.15-2.29-.43-4.73.28-6.88s2.44-4,4.16-5.74c5.16-5,10.18-10,15.34-14.9a10.51,10.51,0,0,1-.58,8.31c-.86,1.72-2.29,3.15-2.86,5a12.06,12.06,0,0,0-.43,3.29c0,5.74,1,11.62.28,17.35s-3.72,11.75-9.17,13.76a2.44,2.44,0,0,1-1.43.14,2.28,2.28,0,0,1-1-.57,18.6,18.6,0,0,1-6.45-9.6C361.26,245.76,364.27,243,364.13,239.31Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-28)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M233.06,324.9c-3.44,6.45-3.83,7.87-13.39,14.32a3.54,3.54,0,0,1-.86,1.15,2.52,2.52,0,0,1-1,.14c-9.6.43-19.2-1.58-28.67-2.58-17.77-1.72-59.28-.92-71.81-8.17-7.31-2.3-21.42-12.8-21.27-20.4,0-5.45-.68-17.49,3.62-20.78.55-.41.82-4.69,1.75-4.77,1.88-3.26.73-4.22,7.84-18.33C127,230.25,141.09,221,148.91,218.15s10.09,37.14,8.89,42.79-19.68,38.59-19.68,38.59,10.33,2.94,17.76,4.86c24.51,6.45,50.17,7.88,75.54,9.17C231.85,315.71,234.07,322.9,233.06,324.9Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#aa68fc"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M232.87,321.67c-3.44,6.45-3,7.69-6.47,14.14-.28.43-8.14,3.74-8.5,4.57,0,.09-.07.13-.1.13-9.6.43-19.2-1.58-28.67-2.58-17.77-1.72-59.28-.92-71.81-8.17-7.31-2.3-21.42-12.8-21.27-20.4,0-5.45-.68-17.49,3.62-20.78.55-.41.82-4.69,1.75-4.78,1.88-3.25.73-4.21,7.84-18.33C127,230.25,141.09,221,148.91,218.15s10.09,37.14,8.89,42.79-19.68,38.59-19.68,38.59,10.38,3,17.76,4.86c24.27,6.39,49.65,7.85,74.78,9.13l.76,0C231.85,315.71,233.87,319.67,232.87,321.67Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-29)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M232.87,321.67c-3.44,6.45-2.89,6.81-6.33,13.26-.29.43-8.28,4.62-8.64,5.45a9,9,0,0,1-1.17-1.38,13.48,13.48,0,0,1-1-13.28,19.29,19.29,0,0,1,4.33-5.52,32.27,32.27,0,0,1,10.56-6.68l.76,0C231.85,315.71,233.87,319.67,232.87,321.67Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-30)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M243.14,320.91c2,.86,3.87,1.86,5.74,2.87,10.17,5.44,20.35,11,29.38,18.06,1,.86,2.15,1.86,2.15,3.15,0,1.72-1.86,2.73-3.58,3.3a36.26,36.26,0,0,1-23.37-.57c-5.73-2.15-11.18-5.74-17.2-6.31A42,42,0,0,1,232,341a18.35,18.35,0,0,1-5.87-2.72c-3.73-2.3-7.6-5.74-7.31-10.18.43-7.17,8.74-9,14.62-9,3.29,0,6.59,1.14,9.74.86,5.16-.43,10.47.57,15.77.57a3.68,3.68,0,0,1,2.44.57,2.59,2.59,0,0,1,.43,3c-1,2.58-4,3.73-6.74,4.3-2.87.72-5.88,1.29-8.74.72a5.9,5.9,0,0,1-3.87-2.44,6.21,6.21,0,0,1-.86-2.29,6.61,6.61,0,0,1,.57-3.73",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-31)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M134.49,427.09a146.82,146.82,0,0,0,103.93-11.61c-.43,6.3,24.79,98,29.81,115a3.29,3.29,0,0,0,3.44,2.29c7.45-.86,9.75,3.58,28.38-7-13.33-10-9.17-113.67-16.48-128.58-3.87-7.89-7.46-16.92-15.48-20.5-8.89-4-20.79.29-28.24-6,0,0-7.12-9.31-34,1.45S134.2,421.31,134.49,427.09Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#525263"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M134.49,427.09a146.82,146.82,0,0,0,103.93-11.61c-.43,6.3,24.79,98,29.81,115a3.29,3.29,0,0,0,3.44,2.29c7.45-.86,9.75,3.58,28.38-7-13.33-10-9.17-113.67-16.48-128.58-3.87-7.89-7.46-16.92-15.48-20.5-8.89-4-20.79.29-28.24-6,0,0-7.12-9.31-34,1.45S134.2,421.31,134.49,427.09Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-32)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 225.19,
    y: 336.8,
    width: 380.29,
    height: 29.82,
    fill: "#aa68fc"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M279.55,552.65a4.68,4.68,0,0,0,1.72,2.3,7.49,7.49,0,0,0,2.59.57c13.47.15,26.37-4.73,39-9.46,3.3-1.29,6.6-2.58,9.18-5s3.72-6.45,2.15-9.6c-2-3.73-7-4.44-11.18-4.59-6.31-.28-12.62-.71-18.92-1a14.15,14.15,0,0,0-3.44.14,25.77,25.77,0,0,0-4.16,1.72,50.8,50.8,0,0,1-10.61,4.3c-2.58.72-6.45.72-8.6,2.73C272.67,539,277.55,548.07,279.55,552.65Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#aa68fc"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M279.55,552.65a4.68,4.68,0,0,0,1.72,2.3,7.49,7.49,0,0,0,2.59.57c13.47.15,26.37-4.73,39-9.46,3.3-1.29,6.6-2.58,9.18-5s3.72-6.45,2.15-9.6c-2-3.73-7-4.44-11.18-4.59-6.31-.28-12.62-.71-18.92-1a14.15,14.15,0,0,0-3.44.14,25.77,25.77,0,0,0-4.16,1.72,50.8,50.8,0,0,1-10.61,4.3c-2.58.72-6.45.72-8.6,2.73C272.67,539,277.55,548.07,279.55,552.65Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-33)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M618.85,432.53c-9.47,2.58-19.07,6.45-24.52,15.2A17.88,17.88,0,0,0,592,462.21c3.15,10.89,15.48,13.47,26,14.76,20.78,2.44,41.85,4,62.78,2,15.77-1.58,32.54-5.74,42.57-17.92,3.73-4.44,6.31-9.75,8.6-15.2,10-24.94,11-52.46,12-79.41.15-3.29.15-6.59.15-9.89-.15-13-18.06-16.62-23.08-4.44-3,7.31-5.59,13.47-6.17,15.34-5.16,15.76-6.88,36.84-14.47,51.31-6.6,12.62-14.62,9.61-27.81,8.6A158.24,158.24,0,0,0,618.85,432.53Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#3f3d56"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M618.85,432.53c-9.47,2.58-19.07,6.45-24.52,15.2A17.88,17.88,0,0,0,592,462.21c3.15,10.89,15.48,13.47,26,14.76,20.78,2.44,41.85,4,62.78,2,15.77-1.58,32.54-5.74,42.57-17.92,3.73-4.44,6.31-9.75,8.6-15.2,10-24.94,11-52.46,12-79.41.15-3.29.15-6.59.15-9.89-.15-13-18.06-16.62-23.08-4.44-3,7.31-5.59,13.47-6.17,15.34-5.16,15.76-6.88,36.84-14.47,51.31-6.6,12.62-14.62,9.61-27.81,8.6A158.24,158.24,0,0,0,618.85,432.53Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-34)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M634.33,187.56c1.57,1.72,3.58,2.87,5,4.59,4.3,4.87,3.73,13,8.89,17.06a15.69,15.69,0,0,0,7.17,2.72c7.45,1.29,15.48,1.15,21.79-3,4.44-3,7.45-7.6,9.89-12.33,4.58-9.74,6.59-21.07,3.87-31.53-4.3-15.91-27.1-33.11-42.15-18.35-4.58,4.44-4,11.75-4.87,17.63-.72,4.73-1.72,9-5.16,12.76C635.62,180.11,629.74,182.26,634.33,187.56Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-35)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M636.19,157.32a6.74,6.74,0,0,0,.72,2.43,5.3,5.3,0,0,0,2.86,1.72,84,84,0,0,0,18.92,4.3c1.29-1.43,2.73-2.86,4-4.3a15.84,15.84,0,0,1,.43,5.16,119.1,119.1,0,0,0,12.33,3.16c1.43,15.77-3,31.39-7.46,46.58a119.16,119.16,0,0,0,48.16,6.45c5.17-17.48,8.61-36,5.45-54s-13.47-35.54-29.81-43.57c-12.9-6.31-28.39-5.88-41.43-.29C638.63,130.08,634.76,145.71,636.19,157.32Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#3f3d56"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M717,297.79c-2,24.94-4,49.74-6,74.68-.71,9.61-1.57,19.35-4.3,28.67A70.35,70.35,0,0,1,678.91,439c-13.62,9.18-29.82,13.19-45.73,17.06-23.65,5.74-37.89,1.85-47.58,18-40-12.51-44.56-38.74-44-49.77.57-10.61,7.53-16.42,23.2-22.11,26.31-13.14,37.26-15.77,55.76-25.09,21.5-10.89,32.53-35.26,38-58.77s-5.75-49.68,4.14-71.62c5.73-12.75,23.51-30.1,36-15.48C711,246,718.47,280.59,717,297.79Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#aa68fc"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M717,297.79c-2,24.94-4,49.74-6,74.68-.71,9.61-1.57,19.35-4.3,28.67A70.35,70.35,0,0,1,678.91,439c-13.62,9.18-29.82,13.19-45.73,17.06-23.65,5.74-37.89,1.85-47.58,18-40-12.51-44.56-38.74-44-49.78.58-10.61,7.53-16.41,23.2-22.1,26.31-13.13,37.26-15.77,55.76-25.09a50.94,50.94,0,0,0,4.5-2.58h16.57v-16c8.35-11.62,13.64-26.05,16.91-40.16,5.3-23.51-5.75-49.68,4.14-71.61,5.74-12.76,23.51-30.11,36-15.48S718.47,280.59,717,297.79Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-36)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M695.78,265.78s-2.43,85.57-16.95,100.09-84,46-90.4,47.63c-6.27,1.55-33.21,16.2-34.17,16.68l-.54-22.61,71.35-33.09h16.57v-16c8.14-16,23.48-52.31,23.48-52.31Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-37)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M563.52,541.19a4.07,4.07,0,0,0-2.3-.43,15.19,15.19,0,0,0-1.43.57,103.53,103.53,0,0,0-23.37,19.93c-.28.43-.71.86-.71,1.29,0,.71.71,1.14,1.29,1.43,4.58,2.15,9.89,1.58,14.76.43A75.2,75.2,0,0,0,573,556.1c4.3-2.44,8.6-3.88,11.89.71,2.15,3,3.3,8.46,8.17,4.59s-.14-18.06-2.43-22.36C581.58,542.62,573.12,544.77,563.52,541.19Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#3f3d56"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M243.72,143.7c.14,6,1.86,12.9,7.17,15.48,1.14.57,2.58,1,3.44,2.15,1.14,1.58.28,4-1.15,5.45s-3.3,2.29-4.87,3.58c-3.16,2.58-4.45,6.74-5,10.75s-.86,8-2.29,11.76a18.46,18.46,0,0,1-14.48,11.32c-2.73.29-5.59,0-8.46.29s-5.73,1.29-7.31,3.58c-2,2.87-1.43,7.17-3.87,9.46s-6.59,1.72-9.89.72c-3.87-1-8-2.3-10.18-5.59a13.68,13.68,0,0,1-1.86-5.74c-1.86-11.75.86-23.79-.86-35.4-.72-4.59-2.15-9-2.72-13.76a45.5,45.5,0,0,1,.86-17.63c2-7.74,6.45-15.34,13.47-19.07,5.73-3,12.61-3.3,19.21-2.87a75.53,75.53,0,0,1,24.37,5.6C246,126.64,243.58,137.39,243.72,143.7Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-38)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M238.27,113a20.41,20.41,0,0,1,5.59,6c1.29,2.44,1.44,5.74-.43,7.89-1.43,1.72-3.87,2.44-6,3-9.46,2.44-20.07,4.44-28.67-.29a2,2,0,0,0-.86-.28c-.86,0-1.43,1-1.57,1.86a152.34,152.34,0,0,0-4.45,30.1c-1.14.43-2-1-2.58-2a7,7,0,0,0-3.15-3.29c-1.43-.72-3.3-.72-4.3.43a5.09,5.09,0,0,0-1.15,1.86c-1.86,5.45,1.58,12.18,7,13.9-3.44,2.44-5,6.6-7,10.33a31.52,31.52,0,0,1-4.3,6.45c-1.14,1.29-2.43,2.72-4.15,2.86a4.83,4.83,0,0,1-4-2,17.09,17.09,0,0,1-2-4.3c-1.15-3.44-2.16-6.74-3.3-10.18a105.15,105.15,0,0,1-3.3-11.47A100.48,100.48,0,0,1,168,152.44c-.28-3-.57-5.87-.86-8.88a29.37,29.37,0,0,1-.14-7.89c.43-3.72,2.15-7.16,4-10.6a29.42,29.42,0,0,1,4.45-6.6,10.28,10.28,0,0,1,7-3.15,9.62,9.62,0,0,0,2,0,4.18,4.18,0,0,0,1.58-1.15,37,37,0,0,1,18.63-8.46,69.41,69.41,0,0,1,19.64-.57C229.53,106,234.12,109.87,238.27,113Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#3f3d56"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M223,204.16s-14.26-4.84-18.83-1.07S197,218.24,197,218.24s6.38,2.15,9.89-.72,2.26-8.92,6.21-10.94S223,204.16,223,204.16Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-39)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 288.69,
    y: 365.67,
    width: 229.2,
    height: 209.51,
    fill: "#aa68fc"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 288.69,
    y: 366.48,
    width: 229.2,
    height: 208.7,
    fill: "url(#linear-gradient-40)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M231,316.77l3.76,1.07-.13,1.21s-7.53.67-9.82,3.9-7.67,8.21-.67,14l-3.1,1.22s-6.05-3.77-3.63-9S220.89,320.13,231,316.77Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M361.34,246.2l1.55-1.54s7.87,14.39,8.87,14.79-1.68,2.43-1.68,2.43S361.14,252.93,361.34,246.2Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 224.79,
    y: 336.8,
    width: 380.29,
    height: 29.82,
    fill: "url(#linear-gradient-41)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M277.05,546.88s25.63-1.41,35.92-7.06,11.51-4.24,11.51-4.24l-.2,8.88s-30.88,13.92-43.69,9.48Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-42)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M230.84,556s11.3,9.15,18.84,11.57,19.24,10.36,22.2,9.28a9.77,9.77,0,0,0,4.57-3.76s2.5,2.63,1.72,4.54-2.8,7.7-11.94,2.86-29.87-11.84-33.37-15.74A9.69,9.69,0,0,1,230.84,556Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-43)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M681.34,224.83c-2.86-.43-5.73-.86-8.45,0a17,17,0,0,0-6.74,4.3c-12.76,11.61-12.9,38.42-18.92,54.62s-8.32,24.36-24.37,30.24c-7.88,2.87-29.39,3.15-33.11,10.61-1.58,3-1.58,6.45-1.58,9.89,0,5.73.57,12,4.44,16.34,4.73,5,12.47,5.3,19.36,4.87,9.17-.57,18.49-1.57,27.52-3,7.31-1.14,14.62-2.72,20.92-6.45,7.46-4.3,13.05-11,17.49-18.35,12.76-21.07,16.06-46.3,18.92-70.66.72-6.45,4.16-18.35,1.15-24.66C695.39,227,686.79,225.69,681.34,224.83Z",
    transform: "translate(-36.16 -7.86)",
    fill: "#aa68fc"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M681.34,224.83c-2.86-.43-5.73-.86-8.45,0a17,17,0,0,0-6.74,4.3c-12.76,11.61-12.9,38.42-18.92,54.62s-8.32,24.36-24.37,30.24c-7.88,2.87-29.39,3.15-33.11,10.61-1.58,3-1.58,6.45-1.58,9.89,0,5.73.57,12,4.44,16.34,4.73,5,12.47,5.3,19.36,4.87,9.17-.57,18.49-1.57,27.52-3,7.31-1.14,14.62-2.72,20.92-6.45,7.46-4.3,13.05-11,17.49-18.35,12.76-21.07,16.06-46.3,18.92-70.66.72-6.45,4.16-18.35,1.15-24.66C695.39,227,686.79,225.69,681.34,224.83Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-44)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M593,325a3,3,0,0,1,1.58.57,2.6,2.6,0,0,1,.43,1.86v9c0,2.59,0,5.6-1.86,7.6-1.58,1.72-4,2.3-6.45,2.58-7.6.72-15.34-.71-23.08-1.29a118,118,0,0,0-21.36.29,3.56,3.56,0,0,1-2.44-.29c-1.57-1-.57-3.44.58-5,2-2.59,4-5.31,6.16-7.89a16,16,0,0,1,3.73-3.87c2.72-2,6.16-2.15,9.46-2a54.39,54.39,0,0,0,9.6-1.29A72.81,72.81,0,0,1,593,325Z",
    transform: "translate(-36.16 -7.86)",
    fill: "url(#linear-gradient-45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobInterviewMonochromatic);
export default __webpack_public_path__ + "static/media/Job Interview _Monochromatic.90f7440321d567f82cc68cb9d979154f.svg";
export { ForwardRef as ReactComponent };